import { Component, ElementRef, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { periodicidadeTodoPeriodo } from '../../../../../shared';
import { TituloReceberFilter } from '../../../filter';
import { isPerspectivaEmAberto, isPerspectivaPagos, isPerspectivaVencidos } from '../../../perspectiva';
import { TituloReceberTableComponent } from '../../../view/table';
import { TituloReceberSearch } from '../../../titulo-receber-search';

export interface TituloReceberCliente {
    idPessoa: number;
    codigoIntegracaoErpPessoa: string;
    tipoPessoa: number;
    cnpjCpfPessoa: string;
    nomePessoa: string;
    nomeFantasiaPessoa: string;
}

@Component({
    selector: 'sgt-titulo-receber-cliente-view-modal',
    templateUrl: './titulo-receber-cliente-view-modal.component.html',
    styleUrls: ['./titulo-receber-cliente-view-modal.component.less']
})
export class TituloReceberClienteViewModalComponent implements OnInit {
    elModal: any;
    isOpen: boolean

    title = 'Títulos a receber do cliente';
    cliente: TituloReceberCliente;
    perspectiva: number;
    filter: TituloReceberFilter;

    @Output() editTitulo = new EventEmitter<TituloReceberSearch>();
    @Output() visualizarTitulo = new EventEmitter<TituloReceberSearch>();

    @ViewChild('table') table: TituloReceberTableComponent;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.setTitle();
                this.searchTitulos();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                this.clear();
                this.isOpen = false;
                e.stopPropagation();
            });
    }

    /** Seta o title da modal */
    private setTitle() {
        if (isPerspectivaEmAberto(this.perspectiva)) { // Em Aberto
            this.title = 'Títulos a receber em aberto do cliente';
        } else if (isPerspectivaPagos(this.perspectiva)) { // Pagos
            this.title = 'Títulos a receber pagos do cliente';
        } else if (isPerspectivaVencidos(this.perspectiva)) { // Vencidos
            this.title = 'Títulos a receber vencidos do cliente';
        } else { // Default
            this.title = 'Títulos a receber do cliente';
        }
    }

    private searchTitulos() {
        // Criando filtro dos títulos para o cliente com a perspectiva informada e com periodicidade de todo o período
        this.filter = new TituloReceberFilter(periodicidadeTodoPeriodo);
        this.filter.perspectiva = this.perspectiva;
        this.filter.idsPessoas = [this.cliente.idPessoa];

        setTimeout(() => this.table?.search(), 0);
    }

    /** Abre o modal */
    open(cliente: TituloReceberCliente, perspectiva: number) {
        this.cliente = cliente;
        this.perspectiva = perspectiva;
        this.isOpen = true;
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    /** Fecha o modal */
    close() {
        this.elModal.modal('hide');
    }

    /** Limpas as variáveis utilizadas no modal */
    private clear() {
        this.cliente = null;
        this.perspectiva = null;
        this.filter = null;
    }

}
